import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, first } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCurrentPage } from '@app/modules/organization/store/selectors/organization.selectors';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {
  public endpoint: string = environment.apiAuthUrl + '/locations';
  public endpointNonAuth:string = environment.apiUrl + '/locations';
  
  constructor(private _http: HttpClient, private store$: Store) { 

  }

  readLocationImages(): Observable<any>{
    return this._http.get(`${this.endpoint}/images`);
  }

  readLocations(form, id): Observable<any>{
    return this._http.patch(`${this.endpointNonAuth}/${id}`, {
      form
    });
  }
  /* start multilocations service */
  onGetLocations(sortType, direction) {
    let currentPage;
    this.store$.select(selectCurrentPage).pipe(first()).subscribe(current => currentPage = current ?? 0);
    return this._http.get<any>(`${this.endpointNonAuth}/all`, {
      params: {
        sortType: sortType,
        direction: direction,
        currentPage: currentPage
      }
    });
  }

  onMyLocations(sortType, direction) {
    let currentPage;
    this.store$.select(selectCurrentPage).pipe(first()).subscribe(current => currentPage = current ?? 0);
    return this._http.get<any>(`${this.endpointNonAuth}/my`, {
      params: {
        sortType: sortType,
        direction: direction,
        currentPage: currentPage
      }
    });
  }

  onDeleteLocation(id) {
    return this._http.delete<any>(`${this.endpointNonAuth}/${id}`);
  }

  onGetLocation(id): Observable<any> {
    return this._http.get<any>(`${this.endpointNonAuth}/${id}`);
  }

  onUpdateLocation(id, location): Observable<any> {
    return this._http.put<any>(`${this.endpointNonAuth}/${id}`, location);
  }

  onGetUsersUniqueLocations(id){
    return this._http.get<any>(`${this.endpointNonAuth}/users/${id}`);
  }

  onAssignNewLocation(current_location, new_location){
    return this._http.post<any>(`${this.endpointNonAuth}/assignLocation`, {
      params: {
        current_location: current_location,
        new_location: new_location
      }
    });
  }

  exportExcel(){
    return this._http.post<any>(`${this.endpointNonAuth}/exportLocations`,{});
  }

  importExcel(keys: {}[], locations: {}[]) {
    let headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    return this._http.post<any>(`${this.endpointNonAuth}/import`, {
      keys,
      locations
    }, { headers });
  }
  /* end multilocations service */
}
